export const FETCH_REVIEWS_REQUEST = 'FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_FAILURE = 'FETCH_REVIEWS_FAILURE';

export const FETCH_PUBLIC_COTTAGE_REQUEST = 'FETCH_PUBLIC_COTTAGE_REQUEST';
export const FETCH_PUBLIC_COTTAGE_SUCCESS = 'FETCH_PUBLIC_COTTAGE_SUCCESS';
export const FETCH_PUBLIC_COTTAGE_FAILURE = 'FETCH_PUBLIC_COTTAGE_FAILURE';

export const POST_REVIEW_REQUEST = 'POST_REVIEW_REQUEST';
export const POST_REVIEW_SUCCESS = 'POST_REVIEW_SUCCESS';
export const POST_REVIEW_FAILURE = 'POST_REVIEW_FAILURE';

export const POST_REVIEW_REPLY_REQUEST = 'POST_REVIEW_REPLY_REQUEST';
export const POST_REVIEW_REPLY_SUCCESS = 'POST_REVIEW_REPLY_SUCCESS';
export const POST_REVIEW_REPLY_FAILURE = 'POST_REVIEW_REPLY_FAILURE';

export const REVIEWS_SET_REPLY_FORM_ID = 'REVIEWS_SET_REPLY_FORM_ID';
export const REVIEWS_RESET_LIST = 'REVIEWS_RESET_LIST';

export const DELETE_REVIEW_REQUEST = 'DELETE_REVIEW_REQUEST';
export const DELETE_REVIEW_FAILURE = 'DELETE_REVIEW_FAILURE';
export const DELETE_REVIEW_SUCCESS = 'DELETE_REVIEW_SUCCESS';

export const DELETE_REVIEW_REPLY_REQUEST = 'DELETE_REVIEW_REPLY_REQUEST';
export const DELETE_REVIEW_REPLY_FAILURE = 'DELETE_REVIEW_REPLY_FAILURE';
export const DELETE_REVIEW_REPLY_SUCCESS = 'DELETE_REVIEW_REPLY_SUCCESS';
